// extracted by mini-css-extract-plugin
export var createdDate = "_mb-1";
export var divider = "_mb-2";
export var headerDivider = "_mb-3";
export var messagesCard = "_mb-0";
export var messagesContainer = "_mb-7";
export var messagesContainerWrapper = "_mb-4";
export var pointerCapturingButtonBoxes = "_mb-a";
export var showLeftPanelButton = "_mb-9";
export var showMoreButton = "_mb-c";
export var showMoreButtonContainer = "_mb-b";
export var summaryTitle = "_mb-6";
export var systemMessageCardWrapper = "_mb-d";
export var topButtons = "_mb-8";
export var withPadding = "_mb-5";